import React from 'react';
import ReadAlsoSection from './ReadAlsoSection';
import FeaturedEvent from './FeatuedEvent';
import { Article } from '@/types/Blog';

interface FeaturedContentProps {
  featuredArticle: Article;
  readAlsoArticles: Article[];
  hasArticles: boolean;
  selectedCategory: string | null;
}

const FeaturedContent: React.FC<FeaturedContentProps> = ({ 
  featuredArticle, 
  readAlsoArticles,
  selectedCategory
}) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-6 w-[80%] ">
      <div className="lg:col-span-4 z-20">
        <FeaturedEvent featuredArticle={featuredArticle} />
      </div>
      
      <div className="lg:col-span-2 mt-5 hidden lg:block">
        {readAlsoArticles.length > 0 ? (
          <ReadAlsoSection articles={readAlsoArticles} />
        ) : (
          <div className="bg-gray-50 p-4 rounded">
            <h2 className="text-2xl font-bold mb-4">Baca Juga</h2>
            <p className="text-gray-500">Tidak ada artikel lain dalam kategori {selectedCategory || 'ini'}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default FeaturedContent;